// extracted by mini-css-extract-plugin
export default {"root":"ResetPassword_root__nrij0","button_container":"ResetPassword_button_container__-YMQr","link":"ResetPassword_link__2wV+H","message":"ResetPassword_message__m7Sv2"};